import { styled as r } from "styled-components";
import { Theme as o } from "../../../../styles/themes/index.js";
import { MediaQuery as e } from "../../../../styles/variables.js";
const d = r.div`
  background-color: rgb(${o.colors.Juliet});
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  gap: 20px;

  border-top: 2px solid rgb(${o.colors.Kilo});
  border-bottom: 2px solid rgb(${o.colors.Kilo});

  @media ${e.SCREEN_MD_UP} {
    display: none;
  }
`;
export {
  d as Container
};
